import axios from 'axios';
import { getUserId, getOrgId, getToken, getSignature } from './auth';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
console.info("Backend URL:", API_URL);
export function getAxiosClient(restPath, signature) {
    let apiClient = axios.create({
        baseURL: `${API_URL}/api/${restPath}`,
        headers: {
            'Content-Type': 'application/json',
            'x-user-id': getUserId(),
            'x-organization-id': getOrgId(),
            'x-signature': signature || getSignature(),
        },
    });
    // Add request interceptor to attach fresh token and organization context to each request
    apiClient.interceptors.request.use(async (config) => {
        try {
            // For signature-based access, do NOT attach Clerk bearer token.
            // Backend auth prefers Clerk when Authorization exists, which would block signature org resolution.
            if (signature) {
                return config;
            }
            const token = await getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            const companyId = new URLSearchParams(window.location.search).get('companyId');
            config.headers['X-Organization-Id'] = companyId || getOrgId();
        }
        catch (error) {
            console.error('Error getting auth token:', error);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
    // Add response interceptor to handle token expiration
    apiClient.interceptors.response.use((response) => response, async (error) => {
        const originalRequest = error.config;
        // Signature-based clients do not use bearer tokens; don't attempt refresh-retry.
        if (signature) {
            return Promise.reject(error);
        }
        // If we get a 401 and haven't already tried to refresh
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                // Get a fresh token
                const token = await getToken();
                if (token) {
                    // Update the authorization header with the new token
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    // Retry the original request
                    return apiClient.request(originalRequest);
                }
            }
            catch (refreshError) {
                console.error('Error refreshing token:', refreshError);
                // If refresh fails, reject with the original error
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    });
    return apiClient;
}
